/**
 * CANTIERE 5 IMMAGINI (feb 2026) — Configurazione condivisa degli slot
 * di acquisizione foto per l'analisi tricologica multiluce.
 *
 * Ordine FISSO e vincolante: il backend attiva le istruzioni di lettura
 * MULTILUCE nel Pass 1 quando riceve esattamente 5 immagini, e il prompt
 * assume questo esatto ordine di invio. Le prime tre viste sono la STESSA
 * zona frontale in tre modalità di luce; le ultime due servono da controllo
 * di distribuzione.
 *
 * Usato da: pages/NewAnalysis.jsx (slot upload) e
 *           components/TrichoBetaCapture.jsx (flusso guidato tricocamera).
 */
export const ANALYSIS_SLOTS = [
  {
    id: "frontale-bianca",
    label: "Frontale — Luce Bianca",
    desc: "Aspetto generale, colore e texture",
    tip: "Inquadra attaccatura e fronte — luce bianca",
    group: "frontale",
  },
  {
    id: "frontale-polarizzata",
    label: "Frontale — Luce Polarizzata",
    desc: "Cute, osti e sebo reale (lettura principale)",
    tip: "Stessa zona frontale — luce polarizzata",
    group: "frontale",
  },
  {
    id: "frontale-uv",
    label: "Frontale — Luce UV",
    desc: "Accumuli e depositi in fluorescenza",
    tip: "Stessa zona frontale — luce UV",
    group: "frontale",
  },
  {
    id: "vertice-polarizzata",
    label: "Vertice — Luce Polarizzata",
    desc: "Controllo distribuzione — sommità del capo",
    tip: "Inquadra la sommità del capo — luce polarizzata",
    group: "controllo",
  },
  {
    id: "occipitale-polarizzata",
    label: "Occipitale — Luce Polarizzata",
    desc: "Controllo distribuzione — nuca e retro",
    tip: "Inquadra nuca e retro — luce polarizzata",
    group: "controllo",
  },
];

export const SLOT_GROUPS = [
  {
    key: "frontale",
    title: "Zona frontale — tre letture di luce",
    subtitle: "Stessa area, tre illuminazioni complementari",
  },
  {
    key: "controllo",
    title: "Controllo distribuzione",
    subtitle: "Per capire se i reperti frontali sono localizzati o diffusi",
  },
];
